module.exports = __webpack_public_path__ + "media/images/components/c04-welcome-boep/image-9214617bf904e54b58a6980a2c677d63.svg";